import { filter, set } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';  
import axios from 'axios';
// components
import { ChroniclesListHead,ChroniclesListToolbar,ChroniclesMoreMenu } from '../sections/reports';

import Page from '../components/Page';
import Label from '../components/Label';
import Scrollbar from '../components/Scrollbar';
import Iconify from '../components/Iconify';
import SearchNotFound from '../components/SearchNotFound';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'title', label: 'Title', alignRight: false },
  { id: 'month' , label: 'Month', alignRight: false },
  { id: 'year', label: 'Year', alignRight: false },
  { id: 'material', label: 'Material', alignRight: false },
  { id: 'image', label: 'Main Image', alignRight: false },
  { id: 'images', label: 'Gallery', alignRight: false },
  { id: 'content', label: 'Article Content', alignRight: false },
  { id: 'action', label: 'Action', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query, roleFilter) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  let filteredArray = stabilizedThis.map((el) => el[0]);

  // Apply text query filter
  if (query) {
    filteredArray = filteredArray.filter((chronicles) => {
      if (
        chronicles.month.toLowerCase().includes(query.toLowerCase()) ||
        chronicles.year.toString().includes(query) ||
        chronicles.material.toLowerCase().includes(query.toLowerCase())
      ) {
        return chronicles;
      }
      return null;
    }
  )
  }

  // Apply role filter
  if (roleFilter) {
    filteredArray = filteredArray.filter((chronicles) =>
      chronicles.role.toLowerCase() === roleFilter.toLowerCase()
    );
  }

  return filteredArray;
}

export default function Chronicles() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('email'); // Default sort by email
  const [filterName, setFilterName] = useState('');
  const [roleFilter, setRoleFilter] = useState(''); // State for role filter
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // State for chronicless
  const [chronicle, setChronicle] = useState([]);
  const [editingchroniclesId, setEditingchroniclesId] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const [material, setMaterial] = useState('');
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [image, setImage] = useState('');
  const [images, setImages] = useState([]);
   const [selectedchronicles, setSelectedchronicles] = useState(null);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [meta, setMeta] = useState(null);
const [metaModalOpen, setMetaModalOpen] = useState(false);
const [pageTitle, setPageTitle] = useState('');
const [pageDescription, setPageDescription] = useState('');




  // Fetch chronicless from the server on component mount
  useEffect(() => {
    fetchchronicless();
    fetchMeta();
  }, []);

  // Fetch chronicless from the server
  const fetchchronicless = async () => {
    try {
      const response = await axios.get('https://cpccbe.org/api/chronicles/chronicles',{ month,year,material }); // Adjust endpoint as necessary 
      setChronicle(response.data);
    } catch (error) {
      console.error("Error fetching chronicles:", error);
    }
  };

  const fetchMeta = async () => {
  try {
    const res = await axios.get('https://cpccbe.org/api/chronicles/meta');
    setMeta(res.data);
    setPageTitle(res.data.pageTitle || '');
    setPageDescription(res.data.pageDescription || '');
  } catch (err) {
    console.log("No meta found (first time)");
  }
};

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = chronicle.map((n) => n.email); // Use email as unique identifier
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, email) => {
    const selectedIndex = selected.indexOf(email);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, email);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  // Handle opening and closing of modal for editing chronicles
  const handleOpenModal = (chroniclesId) => {
    if (chroniclesId) {

      const chroniclestoEdit = chronicle.find(chronicles=> chronicles._id === chroniclesId);
      if(chroniclestoEdit){
       setMonth(chroniclestoEdit.month);
        setYear(chroniclestoEdit.year);
        setMaterial(chroniclestoEdit.material);
        setTitle(chroniclestoEdit.title || '');
        setContent(chroniclestoEdit.content || '');
        setImage(chroniclestoEdit.image || '');
        setImages(chroniclestoEdit.images || []);
        setEditingchroniclesId(chroniclesId);
      }
    } else {
      setMonth('');
      setYear('');
      setMaterial('');
      setTitle('');
      setContent('');
      setImage('');
      setImages([]);
      setEditingchroniclesId(null);
    }
    setOpenModal(true);

  };


  const handleCloseModal = () => {
    setOpenModal(false);
    setMonth('');
    setYear('');
    setMaterial('');
    setTitle('');
    setContent('');
    setImage('');
    setImages([]);
    setEditingchroniclesId(null);

  };

  const handleSaveMeta = async () => {
  try {
    await axios.post('https://cpccbe.org/api/chronicles/meta', {
      pageTitle,
      pageDescription
    });
    fetchMeta();
    setMetaModalOpen(false);
  } catch (err) {
    console.error("Error saving meta:", err);
  }
};



  // Handle adding a new chronicles
  const handleAddchronicles = async () => {
    try {
      const response = await axios.post('https://cpccbe.org/api/chronicles/chronicle',{ month,year,material, title, content, image, images}); // Adjust based on your actual data structure

      fetchchronicless(); // Refresh chronicles list after adding
      handleCloseModal(); // Close modal after adding
    } catch (error) {
      console.error("Error adding chronicles:", error);
    }
  };

  // Handle updating a chronicles
  const handleUpdatechronicles = async () => {
    try {
      await axios.put(`https://cpccbe.org/api/chronicles/update-chronicles/${editingchroniclesId}`, { month,year,material, title, content, image, images }); // Adjust endpoint as necessary
      fetchchronicless(); // Refresh chronicles list after updating
      handleCloseModal(); // Close modal after updating
    } catch (error) {
      console.error("Error updating chronicles:", error);
    }
  };

  // Handle deleting a chronicles
  const handleDeletechronicles = async (chroniclesId) => {
    if (window.confirm("Are you sure you want to delete this chronicles?")) {
      try {
        await axios.delete(`https://cpccbe.org/api/chronicles/deletechronicle/${chroniclesId}`); // Adjust endpoint as necessary
        fetchchronicless(); // Refresh chronicles list after deletion
      } catch (error) {
        console.error("Error deleting chronicles:", error);
      }
    }
  };

  const handleViewchronicles = (chronicles) => {
    // Open a modal or set state to display chronicles details
    setSelectedchronicles(chronicles); // Assuming you have state to hold selected chronicles data
    setViewModalOpen(true); // Open the modal for viewing chronicles details
  };




  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - chronicle.length) : 0;

  // Apply sorting and filtering
  const filteredchronicless = applySortFilter(chronicle, getComparator(order, orderBy), filterName, roleFilter);


  const ischroniclesNotFound = filteredchronicless.length === 0;
  
  return (
<Page title="chronicles">
  <Container maxWidth="xl">

    {/* 🔹 TITLE */}
    <Typography variant="h4" fontWeight={700} sx={{ mb: 3 }}>
      Chronicles
    </Typography>

    {/* 🔹 CONFIG CARD */}
    <Card sx={{ p: 4, mb: 2, borderRadius: 3 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h6" fontWeight={600}>
          Chronicles Configuration
        </Typography>

        <Button
          variant="contained"
          onClick={() => setMetaModalOpen(true)}
          startIcon={<Iconify icon="eva:edit-fill" />}
          sx={{ borderRadius: 2 }}
        >
          Edit Configuration
        </Button>
      </Stack>

      <Stack spacing={3} mt={3}>
        <TextField
          label="Page Title"
          value={meta?.pageTitle || ''}
          fullWidth
          disabled
        />
        <TextField
          label="Page Description"
          value={meta?.pageDescription || ''}
          fullWidth
          multiline
          rows={3}
          disabled
        />
      </Stack>
    </Card>

    {/* 🔹 BUTTON BELOW (RIGHT ALIGNED) */}
    <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }}>
      <Button
        variant="contained"
        onClick={handleOpenModal}
        startIcon={<Iconify icon="eva:plus-fill" />}
        sx={{ borderRadius: 2, px: 3 }}
      >
        New Chronicles
      </Button>
    </Stack>

        <Card>
          <ChroniclesListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            roleFilter={roleFilter}
            onRoleFilterChange={(e) => setRoleFilter(e.target.value)}
          />


          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ChroniclesListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={chronicle.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredchronicless.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const { _id, month,year,material } = row; // Adjust based on your actual data structure
                    const isItemSelected = selected.indexOf(month) !== -1;

                    return (
                      <TableRow
                        hover
                        key={_id}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
<TableCell align="left">
  <IconButton onClick={() => handleViewchronicles(row)} aria-label="view chronicles">
    <Iconify icon="eva:eye-fill" />
  </IconButton>
</TableCell>
                       
                        <TableCell align="left">{row.title}</TableCell>
                        <TableCell align="left">{month}</TableCell>
                        <TableCell align="left">{year}</TableCell>
                        <TableCell align="left">
                          {material ? (
                            <Typography variant="body2" sx={{ maxWidth: 150, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                              {material}
                            </Typography>
                          ) : "None"}
                        </TableCell>
                        <TableCell align="left">{row.image ? "Yes" : "No"}</TableCell>
                        <TableCell align="left">{row.images ? row.images.length : 0}</TableCell>
                        <TableCell align="left">
                          {row.content ? (
                            <Typography variant="body2" sx={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                              {row.content}
                            </Typography>
                          ) : "None"}
                        </TableCell>
                        <TableCell align="left">
                          <ChroniclesMoreMenu
                            onEdit={() => handleOpenModal(row._id)}
                            onDelete={() => handleDeletechronicles(row._id)}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {ischroniclesNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={chronicle.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>

        <Dialog open={metaModalOpen} onClose={() => setMetaModalOpen(false)} maxWidth="sm" fullWidth>
  <DialogTitle>Edit Chronicles Configuration</DialogTitle>

  <DialogContent>
    <TextField
      fullWidth
      label="Page Title"
      margin="dense"
      value={pageTitle}
      onChange={(e) => setPageTitle(e.target.value)}
    />

    <TextField
      fullWidth
      label="Page Description"
      margin="dense"
      multiline
      rows={3}
      value={pageDescription}
      onChange={(e) => setPageDescription(e.target.value)}
    />
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setMetaModalOpen(false)}>Cancel</Button>
    <Button variant="contained" onClick={handleSaveMeta}>
      Save
    </Button>
  </DialogActions>
</Dialog>

        {/* Modal for Editing chronicles */}
        <Dialog open={openModal} onClose={handleCloseModal}>
          <DialogTitle>{editingchroniclesId ? "Edit Chronicles" : "Add New Chronicles"}</DialogTitle>
          <DialogContent>
            <TextField
              margin="dense"
              id="title"
              label="Title"
              type="text"
              fullWidth
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
            <TextField
              margin="dense"
              id="month"
              label="Month"
              type="text"
              fullWidth
              value={month}
              onChange={(e) => setMonth(e.target.value)}
            />
            <TextField
              margin="dense"
              id="year"
              label="Year"
              type="text"
              fullWidth
              value={year}
              onChange={(e) => setYear(e.target.value)}
            />
            <TextField
              margin="dense"
              id="material"
              label="Material Link (PDF/Doc)"
              type="text"
              fullWidth
              value={material}
              onChange={(e) => setMaterial(e.target.value)}
              />
               <TextField
              margin="dense"
              id="image"
              label="Main Image URL"
              type="text"
              fullWidth
              value={image}
              onChange={(e) => setImage(e.target.value)}
              />
               <TextField
              margin="dense"
              id="images"
              label="Additional Image URLs (comma separated)"
              type="text"
              fullWidth
              value={images.join(', ')}
              onChange={(e) => setImages(e.target.value.split(',').map(s => s.trim()))}
              />
              <TextField
              margin="dense"
              id="content"
              label="Article Content"
              type="text"
              fullWidth
              multiline
              rows={4}
              value={content}
              onChange={(e) => setContent(e.target.value)}
              />
              </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseModal}>Cancel</Button>
            {editingchroniclesId ? (
              <Button onClick={handleUpdatechronicles}>Update chronicles</Button>
            ) : (
              <Button onClick={handleAddchronicles}>Add chronicles</Button>
            )}
          </DialogActions>
        </Dialog>

        <Dialog open={viewModalOpen} onClose={() => setViewModalOpen(false)}>
          <DialogTitle>Chronicles Details</DialogTitle>
            <DialogContent>
               <TextField
                margin="dense"
                id="title"
                label="Title"
                type="text"
                fullWidth
                value={selectedchronicles?.title}
                disabled
              />
              <TextField
                margin="dense"
                id="month"
                label="Month"
                type="text"
                fullWidth
                value={selectedchronicles?.month}
                disabled
              />
              <TextField
                margin="dense"
                id="year"
                label="Year"
                type="text"
                fullWidth
                value={selectedchronicles?.year}
                disabled
              />
              <TextField
                margin="dense"
                id="material"
                label="Material"
                type="text"
                fullWidth
                value={selectedchronicles?.material}
                disabled
              />
               <TextField
                margin="dense"
                id="image"
                label="Main Image"
                type="text"
                fullWidth
                value={selectedchronicles?.image}
                disabled
              />
               <TextField
                margin="dense"
                id="images"
                label="Gallery Images"
                type="text"
                fullWidth
                value={selectedchronicles?.images?.join(', ')}
                disabled
              />
               <TextField
                margin="dense"
                id="content"
                label="Article Content"
                type="text"
                fullWidth
                multiline
                rows={4}
                value={selectedchronicles?.content}
                disabled
              />
            </DialogContent>
          <DialogActions>
            <Button onClick={() => setViewModalOpen(false)}>Close</Button>
          </DialogActions>
        </Dialog>


      </Container>
    </Page>
  );
}
